import DelayIndicator from './DelayIndicator';

export default DelayIndicator;